import Icon from '@mdi/react';
import styles from './MenuItem.module.css';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@/lib/useAuth';
import { useMenuGroup } from './useMenuGroup';
import { useEffect } from 'react';

type MenuItemProps = {
  label: string;
  icon: string;
  path?: string;
  action?: () => void;
  badge?: React.ReactNode;
  disabled?: boolean;
  important?: boolean;
  roles?: string[];
};
const MenuItem = ({
  label,
  icon,
  path,
  action,
  badge,
  disabled,
  important,
  roles,
}: MenuItemProps) => {
  const { register, unregister } = useMenuGroup();
  const { user } = useAuth();
  const shouldRender = !roles || roles.includes(user?.papel);

  useEffect(() => {
    if (shouldRender) {
      register();
      return () => unregister();
    }
  }, [shouldRender, register, unregister]);

  if (!shouldRender) return null;

  if (action
    && typeof action === 'function'
  ) {
    return (
      <div className={[
        styles.container,
        important ? styles.important : null,
      ].join(' ')}>
        <button
          className={[
            disabled ? styles.disabled : null,
          ].join(' ')}
          onClick={action}
          disabled={disabled}
        >
          <Icon className={styles.icon} path={icon} size={1} />
          <span className={styles.label}>{label}</span>
          {badge ? <div className={styles.badge}>{badge}</div> : null}
        </button>
      </div>
    );
  }

  if (!path)
    return null

  return (
    <NavLink
      className={({ isActive }) => [
        styles.container,
        isActive ? styles.active : null,
        disabled ? styles.disabled : null,
        important ? styles.important : null,
      ].join(' ')}
      to={disabled ? '#' : path!}
      end
    >
      <Icon className={styles.icon} path={icon} size={0.9} />
      <span className={styles.label}>{label}</span>
      {badge ? <div className={styles.badge}>{badge}</div> : null}
    </NavLink>
  );
};

export default MenuItem;
